var map = {
	"./bluesky.png": 58375,
	"./facebook.png": 66695,
	"./google_business_profile.png": 51143,
	"./instagram.png": 13742,
	"./linkedin.png": 75657,
	"./mastodon.png": 43496,
	"./pinterest.png": 81103,
	"./reddit.png": 23610,
	"./snapchat.png": 7341,
	"./threads.png": 79919,
	"./tiktok.png": 31990,
	"./tumblr.png": 78231,
	"./twitter.png": 97363,
	"./youtube.png": 57990
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12754;